export default "__VITE_PUBLIC_ASSET__07f0a709__"